import React from "react";
// import ThreeDProperties from "../Shared/3DProperties";
import StyleProperties from "../Shared/StyleProperties";
import Coordinates from "../Shared/Coordinates";
import Details from "../Shared/Details";
import ConstrainProportions from "../Shared/ConstrainProportions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { createOrUpdateShape } from "orion-components/GlobalData/Shapes/actions";
import MapDisplayOptions from "../Shared/MapDisplayOptions";

const RectangleEditor = () => {
	const { mapTools } = useSelector((state) => state.mapState);

	const dispatch = useDispatch();

	useEffect(() => {
		const { feature } = mapTools;
		if (feature) {
			const { properties } = feature;
			const {
				polyStroke,
				polyFill,
				polyFillOpacity,
				lineWidth,
				lineType,
				lineStrokeOpacity,
				constrainProportion
			} = properties;
			dispatch(
				createOrUpdateShape("rectangle", {
					constrainProportion,
					polyStroke,
					polyFill,
					polyFillOpacity: polyFillOpacity * 100,
					lineWidth,
					lineStrokeOpacity: lineStrokeOpacity * 100,
					lineType
				})
			);
		}
	}, []);
	return (
		<div>
			<Details shapeName="Shape name" shapeType="rectangle" />
			<ConstrainProportions shapeType="rectangle" />
			{/* <ThreeDProperties /> */}
			<MapDisplayOptions shapeType="rectangle" />
			<StyleProperties shapeType="rectangle" defaultStrokeColor="#96CC63" />
			<Coordinates />
		</div>
	);
};
export default RectangleEditor;
